import { useEffect } from 'react';
import { TextToSpeechService } from '@/services/speech/TextToSpeechService';

/**
 * Hook to warm up the TTS edge function on app initialization
 * This prevents cold starts and improves first-time TTS performance
 */
export const useTTSWarmup = () => {
  useEffect(() => {
    // Warm up TTS service after a short delay to not block initial app loading
    const timer = setTimeout(() => {
      TextToSpeechService.warmupEdgeFunction();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);
};